import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MICRO_SERVICES } from 'src/app/core/services/api.service';
import { ILazyApiResult } from 'src/app/core/services/api/api-result';
import { QueryParams } from 'src/app/core/services/api/query-params';
import { INotif } from '../../core/models/notif.model';
import { GenericService } from '../generic.service';

@Injectable({
  providedIn: 'root'
})
export class NotifService extends GenericService<INotif> {
  private readonly METHOD_CANNOT_BE_USED = 'Method cannot be used';
  private readonly NOTIF = 'notifs';

  constructor(
      private http: HttpClient,
      private router: Router
  ) {
    super(http);
  }

  public getCount(): Observable<number> {
    return this.api.get(MICRO_SERVICES.MS_NOTIF, `${this.NOTIF}/badge-count`);
  }

  public get(queryParams?: QueryParams): Observable<ILazyApiResult<INotif>> {
    return this.api.get(
        MICRO_SERVICES.MS_NOTIF,
        `${this.NOTIF}?${queryParams?.buildParams()}`
    );
  }

  public read?(id: number): Observable<any> {
    return this.api.patch(MICRO_SERVICES.MS_NOTIF, `${this.NOTIF}/${id}/read`);
  }

  public create(): Observable<INotif> {
    throw new Error(this.METHOD_CANNOT_BE_USED);
  }

  public delete(): Observable<void> {
    throw new Error(this.METHOD_CANNOT_BE_USED);
  }

  public getOne(): Observable<INotif> {
    throw new Error(this.METHOD_CANNOT_BE_USED);
  }

  public update(): Observable<INotif> {
    throw new Error(this.METHOD_CANNOT_BE_USED);
  }

  public navigate(url: any) {
    if (url && url.length > 0) {
      // Force reload navigation using router.navigate on specific pages urls
      if (url[0].includes('relocalisation') || url[0].includes('search')) {
        this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(url));
      }
          // Used to pass parameters as QueryParams and not as Params only.
          // This is allowing deletion of params from redirection (dashboard and notif tiles)
          // and allowed the refresh of the page without keeping them in url if the user filter the page with others params.
      // Can change with refacto of mat-tab and integration of real navigation between them.
      else if (url[0].includes('private/management/movements')) {
        this.router.navigate([url[0]], { queryParams: url[1] });
      } else {
        this.router.navigate(url);
      }
    }
  }

  public resetBadgeCount(): Observable<void> {
    return this.api.patch(MICRO_SERVICES.MS_NOTIF, `${this.NOTIF}/badge-count/reset`);
  }

  public readAllNotifs(): Observable<void> {
    return this.api.patch(MICRO_SERVICES.MS_NOTIF, `${this.NOTIF}/read`);
  }
}
